import React from 'react';
import { Tooltip } from 'antd';
import PropTypes from 'prop-types';

export default function TradeOutcomeBar({ outcomes, maxTrades }) {
    // Create array of maxTrades slots
    const slots = Array.from({ length: maxTrades }, (_, index) => {
        const trade = outcomes?.[index];
        return trade || null;
    });

    return (
        <div className="trade-outcome-bar">
            {slots.map((trade, index) => {
                if (!trade) {
                    // Empty slot
                    return <div key={`empty-${index}`} className="outcome-square empty" />;
                }

                const { isWin } = trade;
                const { pnl } = trade;
                const pnlText = pnl >= 0 ? `+$${pnl.toFixed(2)}` : `-$${Math.abs(pnl).toFixed(2)}`;

                return (
                    <Tooltip
                        key={trade.tradeId || `trade-${index}`}
                        title={`Trade ${index + 1}: ${pnlText}`}
                        placement="top"
                    >
                        <div className={`outcome-square ${isWin ? 'win' : 'loss'}`} />
                    </Tooltip>
                );
            })}
        </div>
    );
}

TradeOutcomeBar.propTypes = {
    outcomes: PropTypes.arrayOf(
        PropTypes.shape({
            tradeId: PropTypes.string,
            pnl: PropTypes.number,
            isWin: PropTypes.bool
        })
    ),
    maxTrades: PropTypes.number
};

TradeOutcomeBar.defaultProps = {
    outcomes: [],
    maxTrades: 20
};
